<template>
  <PremiumBanner>
    <template #content="props">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <h3 class="mb-16">
            {{ $label('banners.premiumBanner.title') }}
          </h3>
          <p class="mb-24">
            {{ $label('banners.premiumBanner.text') }}
          </p>
          <BaseButton
            variant="call-to-action"
            class="mb-24"
            :class="[{ loading: props.isRequestingUpgrade }]"
            data-testid="upgrade-btn"
            @click="props.upgradeToPremium"
          >
            {{ $label('banners.premiumBanner.btnText') }}
          </BaseButton>
          <p class="text-small mb-0 fst-italic">
            {{ $label('banners.premiumBanner.caption') }}
          </p>
        </div>
      </div>
    </template>
  </PremiumBanner>
</template>

<script>
import PremiumBanner from './PremiumBanner'

export default {
  components: {
    PremiumBanner,
  },
}
</script>
